import { render, staticRenderFns } from "./LimitAbleLayoutOld.vue?vue&type=template&id=2e72e89f&scoped=true&"
import script from "./LimitAbleLayoutOld.vue?vue&type=script&lang=js&"
export * from "./LimitAbleLayoutOld.vue?vue&type=script&lang=js&"
import style0 from "./LimitAbleLayoutOld.vue?vue&type=style&index=0&id=2e72e89f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e72e89f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VContainer,VDivider,VRadio,VRadioGroup})
